






















































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import { TextField } from '@/components/atoms';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import Trigger from '@/componentsV2/molecules/Trigger/Trigger.vue';
import CustomersImportCampaignList from '@/componentsV2/organisms/CustomersImportCampaignList/CustomersImportCampaignList.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import CustomerImportService from '@/api/CustomerImportService';

import {
  ECustomerLeadListFilterAlias,
  ICustomerImport,
  ICustomerImportCampaign
} from '@/models/customer-import';

import PaginationUtils, {
  EPaginationSortDir,
  IPagination,
  IPaginationTableHeader
} from '@/utils/PaginationUtils';
import { omitNilProperties } from '@/utils/omitNilProperties';

import DateUtils from '@/utils/DateUtils';
import { ECustomerImportSteps } from '../Modals/CustomerImportModal/CustomerImportModal.vue';
import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import UseFilterByTags from '@/componentsV2/organisms/FilterByTags/UseFilterByTags.vue';
import FilterByTags, {
  Tag
} from '@/componentsV2/organisms/FilterByTags/FilterByTags.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    SectionWrapper,
    CustomersImportCampaignList,
    Trigger,
    FilledButton,
    TextField,
    CustomSelect,
    FilterByTags
  }
})
export default class CustomerImportList extends Mixins(UseFilterByTags) {
  @Prop() campaign!: ICustomerImportCampaign;

  customerImportService = new CustomerImportService();

  createCampaignLoading = false;
  pagination: IPagination = PaginationUtils.defaultPagination();
  filters: Record<string, any> = {};
  filtersTags: Tag[] = [];
  headers: Record<string, IPaginationTableHeader> = {
    importedAt: {
      label: 'Date added',
      sortable: true,
      sortDir: EPaginationSortDir.DESC
    },
    firstName: {
      label: 'Customer',
      sortable: true
    },
    email: {
      label: 'Email',
      sortable: true
    },
    invitationSent: {
      label: 'Invitation Sent',
      sortable: false,
      textAlign: 'center'
    },
    opened: {
      label: 'Opened',
      sortable: false,
      textAlign: 'center'
    },
    linkClicked: {
      label: 'Link clicked',
      sortable: false,
      textAlign: 'center'
    },
    loyaltyCustomer: {
      label: 'Loyalty Member',
      sortable: false,
      textAlign: 'center'
    }
  };
  importedAt: null | string = null;
  campaignCreatedAt: null | string = null;
  customers: ICustomerImport[] = [];
  firstRequestIsLoading = false;
  actionGroup = new CustomSelectGroup(
    this.selectOptions.map(
      ({ value, label }) => new CustomSelectOption(value, label)
    )
  );
  debounceSearch: any = null;
  search = {
    placeholder: 'Search by name or email',
    term: ''
  };

  get tPrefix() {
    return 'customerImport.customersList';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get customerImportV2() {
    return this.flags.includes('customer-import-v2');
  }

  get showCreateCampaign() {
    return (
      this.campaignCreatedAt !== null &&
      !this.campaignCreatedAt &&
      !this.customerImportV2
    );
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get selectOptions() {
    return [
      { value: '', label: 'All Customers' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' }
    ];
  }

  get customFilter() {
    return new CustomSelectModel(
      [this.actionGroup],
      `Customer status`,
      false,
      false,
      false,
      true
    );
  }

  get validFilters() {
    return omitNilProperties(this.filters);
  }

  initFilters() {
    this.filtersTags = [
      {
        label: this.$t(`${this.tPrefix}.filters.invitationSent`) as string,
        type: ECustomerLeadListFilterAlias.INVITATION_SENT
      },
      {
        label: this.$t(`${this.tPrefix}.filters.emailsOpened`) as string,
        type: ECustomerLeadListFilterAlias.EMAILS_OPENED
      },
      {
        label: this.$t(`${this.tPrefix}.filters.linksClicked`) as string,
        type: ECustomerLeadListFilterAlias.LINKS_CLICKED
      },
      {
        label: this.$t(`${this.tPrefix}.filters.loyaltyCustomers`) as string,
        type: ECustomerLeadListFilterAlias.LOYALTY_CUSTOMERS
      },
      {
        label: this.$t(
          `${this.tPrefix}.filters.pendingLoyaltyCustomers`
        ) as string,
        type: ECustomerLeadListFilterAlias.PENDING_CUSTOMERS,
        tooltipText: this.$t(
          `${this.tPrefix}.filters.pendingLoyaltyCustomersTooltip`
        ) as string
      },
      {
        label: this.$t(`${this.tPrefix}.filters.emailsNotSent`) as string,
        type: ECustomerLeadListFilterAlias.EMAILS_NOT_SENT,
        tooltipText: this.$t(
          `${this.tPrefix}.filters.emailsNotSentTooltip`
        ) as string
      }
    ];
  }

  created() {
    this.debounceSearch = debounce((fieldValue: string) => {
      this.handleSearch(fieldValue);
    }, 800);
    this.initFilters();
  }

  mounted() {
    this.reloadCustomerImportList();
    eventBus.$on('reloadCustomerImportList', this.reloadCustomerImportList);
  }

  beforeDestroy() {
    eventBus.$off('reloadCustomerImportList', this.reloadCustomerImportList);
  }

  handleSelectChange(event: CustomSelectOption[]) {
    const [selectedOption] = event;
    // TODO: Apply filter
  }

  handleSearch(value: string) {
    this.filters = {
      ...this.filters,
      search: value
    };

    this.loadCustomers({ clearList: true });
  }

  @Watch('filteredTags')
  handleFilterChange() {
    this.filters = {
      ...this.filters,
      status: this.filteredTags[0]
    };

    this.loadCustomers({ clearList: true });
  }

  async reloadCustomerImportList() {
    this.loadCustomers({
      clearList: true,
      showLoader: false,
      isFirstRequest: true
    });
  }

  async handleOpenCustomerImportModal() {
    this.$analytics({
      eventCategory: `Import Customers | Campaign Detail Page`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Create campaign" button`
    });

    this.createCampaignLoading = true;

    const { data } = await this.customerImportService.getImportStatus(
      this.currentProvider.name
    );

    this.createCampaignLoading = false;

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'customerImportModal',
        false,
        true,
        true,
        true,
        false,
        false,
        false,
        true
      ),
      {
        defaultStep: ECustomerImportSteps.OFFER_CREATION,
        disableStatusPolling: true,
        customerImportFormData: {
          numberOfCustomers: data.total
        }
      }
    );
  }

  formattedCustomers(customers: ICustomerImport[]) {
    return customers.map(item => {
      const date = DateUtils.formattedDate({ date: item.importedAt });
      const hour = DateUtils.formattedDate({
        date: item.importedAt,
        format: 'h:mm a'
      });

      return {
        ...item,
        name: item.firstName
          ? `${item.firstName} ${item.lastName}`
          : item.email,
        importedAt: item.importedAt
          ? this.isMobileDevice
            ? `${date} • ${hour}`
            : `${date}<br />${hour}`
          : '--'
      };
    });
  }

  async loadCustomers({
    clearList = false,
    showLoader = true,
    isFirstRequest = false
  } = {}) {
    if (clearList) {
      this.pagination = PaginationUtils.defaultPagination();
    }

    if (
      this.firstRequestIsLoading ||
      !this.currentProvider ||
      !this.pagination.mustCallApi
    )
      return;

    let endpointPath = `/admin/customer-lead/${this.currentProvider.name}`;
    let queryParameters = this.validFilters;

    if (this.pagination.next) {
      endpointPath = this.pagination.next;
      queryParameters = clearList ? this.validFilters : {};
    }

    if (showLoader) this.$showLoaderWithLocker();
    if (isFirstRequest) this.firstRequestIsLoading = true;

    const response = await this.customerImportService.getCustomeImportsList(
      endpointPath,
      queryParameters
    );

    if (showLoader) this.$hideLoader();
    if (isFirstRequest) this.firstRequestIsLoading = false;

    if (response.status !== 200) return;

    const { items, links, importedAt, campaignCreatedAt } = response.data;

    this.campaignCreatedAt = campaignCreatedAt || '';

    if (importedAt) {
      this.importedAt = DateUtils.formattedDate({
        date: importedAt,
        format: 'MMM D, YYYY h:m:s a',
        applyTimezone: true
      });
    }

    Object.assign(this.pagination, {
      next: links.next,
      mustCallApi: !!links.next
    });

    if (clearList) {
      this.customers = this.formattedCustomers(items);

      return;
    }

    this.customers = [...this.customers, ...this.formattedCustomers(items)];
  }

  handleSort(field: string) {
    this.headers = PaginationUtils.getUpdatedHeaders(field, this.headers);

    const sortDir = this.headers[field].sortDir;

    this.$analytics({
      eventCategory: 'Invite customer - Sort',
      eventAction: 'click',
      eventLabel: `[${sortDir}] ${this.headers[field].label} column`
    });

    this.filters = {
      ...this.filters,
      sort: `${field}:${sortDir}`
    };

    this.loadCustomers({ clearList: true });
  }
}
